import educatorsLogoBlue from '../images/logo/kinedu_educators_color.png';
import EN_LOGO_WHITE from '../images/logo/bg-white-kinedu-educators-en.svg';
import PT_LOGO_WHITE from '../images/logo/bg-white-kinedu-educators-pt.svg';
import ES_LOGO_WHITE from '../images/logo/bg-white-kinedu-educators-es.svg';
import educatorsLogoWhite from '../images/logo/kinedu_educators_white.png';
import educadoresLogoBlue from '../images/logo/kinedu_educadores_color.png';
import educadoresLogoWhite from '../images/logo/kinedu_educadores_white.png';

export const USER_TYPES: any = {
  Admin: { name: 'Admin', id: 4, value: 4 },
  Owner: { name: 'Director', id: 3, value: 3 },
  Director: { name: 'Director', id: 2, value: 2 },
  Teacher: { name: 'Teacher', id: 1, value: 1 },
};

export const RESOURCES = {
  ORGANIZATION: 'organization',
  CENTERS: 'center',
  ADMIN: 'admin',
  DIRECTOR: 'director',
  USER: 'user',
  TEACHER: 'teacher',
};

export const API_SCOPES = {
  ORG_SCOPE: 'organizations',
  CENTER_SCOPE: 'centers',
  GROUPS_SCOPE: 'groups',
};

export interface IStringIndexed {
  [key: string]: any;
}

export const CLIENT_NAMESPACES: IStringIndexed = {
  Owner: 'ownersNamespace',
  Admin: 'adminsNamespace',
  Director: 'directorNamespace',
  Teacher: 'teachersNamespace',
};

export const SUBSCRIPTION_TYPES = {
  DEMO: 'DEMO',
  FREE: 'FREE',
  BASIC: 'BASIC',
  PLUS: 'PLUS',
};

export const ACTIVITY_TYPES = {
  DEVELOPMENTAL: 'developmental_activity',
  INTERACTIVE: 'interactive_session',
  WEBINAR: 'webinar_session',
};

export const educatorsLogo = educatorsLogoBlue;
export const educatorsLogoWhiteEn = EN_LOGO_WHITE;
export const educatorsLogoWhitePt = PT_LOGO_WHITE;
export const educatorsLogoWhiteEs = ES_LOGO_WHITE;
export const educatorsLogoAlt = educatorsLogoWhite;
export const educadoresLogo = educadoresLogoBlue;
export const educadoresLogoAlt = educadoresLogoWhite;


export const DUMMY_ACTIVITIES = [
  {
    id: 5135,
    activity: {
      id: 5130,
      name: 'Catching fun! II',
      description:
        'Find a place to play with your child. Tell {him/her} you are going to practice catching a ball only using your hands. Stand a few feet away from each other and while singing one of {his/her} favorite tunes, start throwing and catching the ball. See if your toddler has any trouble catching it with only {his/her} hands. Grab another ball, ask your child to tell you the differences or similarities between them. Now, give your child a challenge and ask {him/her} to hop on one foot every time {he/she} catches the ball. Once you see {he/she} is catching the ball most of the times, you can pretend the floor is lava, so the ball can’t fall. See how many times you can throw the ball without dropping it! This activity helps your child strengthen {his/her} arms and improve {his/her} throwing, catching and balance abilities.',
      purpose:
        'To encourage your child to practice {his/her} throwing and catching skills.',
      area_id: 1,
      age: 46,
      age_group: '43-48',
      video_thumbnails: {
        size1:
          'https://embed-ssl.wistia.com/deliveries/b1d4537d0c2f29c53d794bc2828886a1.jpg?image_crop_resized=250x250\u0026video_still_time=51',
        size2:
          'https://embed-ssl.wistia.com/deliveries/b1d4537d0c2f29c53d794bc2828886a1.jpg?image_crop_resized=640x640\u0026video_still_time=51',
        size3:
          'https://embed-ssl.wistia.com/deliveries/b1d4537d0c2f29c53d794bc2828886a1.jpg?image_crop_resized=700x366\u0026video_still_time=51',
        size4:
          'https://embed-ssl.wistia.com/deliveries/b1d4537d0c2f29c53d794bc2828886a1.jpg?image_crop_resized=570x260\u0026video_still_time=51',
        size5:
          'https://embed-ssl.wistia.com/deliveries/b1d4537d0c2f29c53d794bc2828886a1.jpg?image_crop_resized=1000x1000\u0026video_still_time=51',
        size6:
          'https://embed-ssl.wistia.com/deliveries/b1d4537d0c2f29c53d794bc2828886a1.jpg?image_crop_resized=1280x930\u0026video_still_time=51',
      },
      video_media: {
        size1:
          'http://embed.wistia.com/deliveries/b55b61126c78bfd5fa337d1d5f6a966f32a36b31.mp4',
        size2:
          'http://embed.wistia.com/deliveries/d71491e17e1ea80c6b2d7f6bd3682ebd885801c8.mp4',
        size3:
          'http://embed.wistia.com/deliveries/371e6529a7914da7ea55b4449725d72883a5e6a2.mp4',
        size4:
          'http://embed.wistia.com/deliveries/9c60f22965a0b8a4a28169dd6ea0228c98af1f51.mp4',
        size5:
          'http://embed.wistia.com/deliveries/b1d4537d0c2f29c53d794bc2828886a1.mp4',
        size6:
          'http://embed.wistia.com/deliveries/926f012ef20c416c5aefedd38cf6444c59fb0dd5.mp4',
      },
      materials: [
        {
          id: 1013,
          name: 'Variety of Plastic Balls',
          description: null,
          link: null,
          price: null,
          created_at: '2018-11-21T02:13:14.000Z',
          updated_at: '2018-11-21T02:13:14.000Z',
          activity_materials_count: 6,
        },
      ],
      milestones: [
        {
          id: 718,
          skill_id: 46,
          sub_skill_id: null,
          master: true,
          age: 48,
          active: true,
          created_at: '2018-11-08T17:35:03.000Z',
          updated_at: '2019-01-08T18:37:02.000Z',
          media_jpg_file_name: null,
          media_jpg_content_type: null,
          media_jpg_file_size: null,
          media_jpg_updated_at: null,
          media_mp4_file_name: '718_Video.mp4',
          media_mp4_content_type: 'video/mp4',
          media_mp4_file_size: 2419219,
          media_mp4_updated_at: '2019-01-08T18:37:02.000Z',
          title: 'Catches a ball mid-air using only {his/her} hands',
          description:
            'If your child can catch with {his/her} hands a ball that is flying in mid-air, then {he/she} has completed this milestone.',
          science_fact:
            'Although it might seem intuitive, catching a ball only using the hands demands plenty of motor planning, hand-eye coordination, sequencing and bilateral skills. Your child’s brain needs to integrate the physical properties of the ball, tighten the lower body muscles to maintain balance whilst following the ball with the eyes and moving the hands to the right angle in order to contract all the tiny muscles needed in the fingers to grip and hold the ball. ',
          source_data: 'Kinedu Research Team, 2018',
        },
        {
          id: 670,
          skill_id: 43,
          sub_skill_id: null,
          master: true,
          age: 43,
          active: true,
          created_at: '2018-11-08T17:35:05.000Z',
          updated_at: '2019-01-08T18:36:20.000Z',
          media_jpg_file_name: '670_Image.jpg',
          media_jpg_content_type: 'image/jpeg',
          media_jpg_file_size: 656018,
          media_jpg_updated_at: '2019-01-08T18:36:19.000Z',
          media_mp4_file_name: null,
          media_mp4_content_type: null,
          media_mp4_file_size: null,
          media_mp4_updated_at: null,
          title: 'Hops on one foot for at least two seconds',
          description:
            'If your toddler can hop on one foot for the duration of two or more seconds, then {he/she} has completed this milestone. ',
          science_fact:
            'Your child’s muscles are continuously contracting, providing {him/her} with enough balance and coordination to be able to jump with only one foot. This ability is integrating efforts of three different systems that are contributing to {his/her} development: the vestibular system, the visual system and the proprioceptive system. ',
          source_data: 'Kinedu Research Team, 2018',
        },
      ],
      activity_type: 'activity',
    },
    complete: false,
  },
  {
    id: 5136,
    activity: {
      id: 5310,
      name: 'What is missing? II',
      description:
        'To begin this activity, sit around a table or the floor and place the small and common objects between you and your child. Then have {him/her} turn around while you remove one of the objects. Ask {him/her} to turn back and count the objects. Ask if anything is different and, if so, to help you figure out what object is missing. By doing this activity you will help your child understand the notions of different and same, as well as practice {his/her} counting skills.',
      purpose:
        'To help your child understand the concepts of different and similar, and to encourage {him/her} to identify what’s changed.',
      area_id: 2,
      age: 46,
      age_group: '43-48',
      video_thumbnails: {
        size1:
          'https://embed-ssl.wistia.com/deliveries/d48f590b1670d1627ee5f9d579a5fac2.jpg?image_crop_resized=250x250\u0026video_still_time=56',
        size2:
          'https://embed-ssl.wistia.com/deliveries/d48f590b1670d1627ee5f9d579a5fac2.jpg?image_crop_resized=640x640\u0026video_still_time=56',
        size3:
          'https://embed-ssl.wistia.com/deliveries/d48f590b1670d1627ee5f9d579a5fac2.jpg?image_crop_resized=700x366\u0026video_still_time=56',
        size4:
          'https://embed-ssl.wistia.com/deliveries/d48f590b1670d1627ee5f9d579a5fac2.jpg?image_crop_resized=570x260\u0026video_still_time=56',
        size5:
          'https://embed-ssl.wistia.com/deliveries/d48f590b1670d1627ee5f9d579a5fac2.jpg?image_crop_resized=1000x1000\u0026video_still_time=56',
        size6:
          'https://embed-ssl.wistia.com/deliveries/d48f590b1670d1627ee5f9d579a5fac2.jpg?image_crop_resized=1280x930\u0026video_still_time=56',
      },
      video_media: {
        size1:
          'http://embed.wistia.com/deliveries/1240a92746f5c92a40d3c27b958c85ff51a9783b.mp4',
        size2:
          'http://embed.wistia.com/deliveries/d26fda9e7529ef8641052c9f077efc37fad56f75.mp4',
        size3:
          'http://embed.wistia.com/deliveries/7f0c514f6a24cd182360b2751bd3ab7097c595b1.mp4',
        size4:
          'http://embed.wistia.com/deliveries/7d7cb942810ae904a295e957f98ac0e72d08055d.mp4',
        size5:
          'http://embed.wistia.com/deliveries/d48f590b1670d1627ee5f9d579a5fac2.mp4',
        size6:
          'http://embed.wistia.com/deliveries/3cdefbf8093ed24538497a201e4118809224976b.mp4',
      },
      materials: [
        {
          id: 764,
          name: '5 Small Everyday Objects',
          description: null,
          link: null,
          price: null,
          created_at: '2018-11-21T02:13:11.000Z',
          updated_at: '2018-11-21T02:13:11.000Z',
          activity_materials_count: 1,
        },
      ],
      milestones: [
        {
          id: 665,
          skill_id: 36,
          sub_skill_id: null,
          master: true,
          age: 48,
          active: true,
          created_at: '2018-11-08T17:35:04.000Z',
          updated_at: '2018-11-08T17:35:04.000Z',
          media_jpg_file_name: null,
          media_jpg_content_type: null,
          media_jpg_file_size: null,
          media_jpg_updated_at: null,
          media_mp4_file_name: null,
          media_mp4_content_type: null,
          media_mp4_file_size: null,
          media_mp4_updated_at: null,
          title:
            'Can identify things that are the same and things that are subtly different',
          description:
            'If your toddler can point out subtle differences between objects that are similar, then {he/she} has completed this milestone.',
          science_fact:
            'For your child, it’s easier to identify similarities and differences when using colorful and everyday objects. Your little one’s brain will grasp obvious distinctive aspects at first to later on detect subtle attributes. This requires logical thinking and attention.',
          source_data: 'Kinedu Research Team, 2018',
        },
      ],
      activity_type: 'activity',
    },
    complete: false,
  },
  {
    id: 5137,
    activity: {
      id: 5372,
      name: 'Treasure hunting with friends I',
      description:
        'To begin this activity, hide the big pieces of a peg puzzle in the sand, making sure they are completely covered. Then, invite a sibling, cousin or friend to play with your child and ask them to recover all the pieces from the sand, so that you can complete the puzzle afterwards. Use this activity to encourage cooperation among peers, and to help your little one learn that working together towards a common goal is easier and more fun than doing something alone.',
      purpose:
        'To engage in teamwork while playing and learn about the benefits of doing tasks as a team.',
      area_id: 4,
      age: 46,
      age_group: '43-48',
      video_thumbnails: {
        size1:
          'https://embed-ssl.wistia.com/deliveries/5c2058392f0f1e5867e134b0e102e00e.jpg?image_crop_resized=250x250\u0026video_still_time=57',
        size2:
          'https://embed-ssl.wistia.com/deliveries/5c2058392f0f1e5867e134b0e102e00e.jpg?image_crop_resized=640x640\u0026video_still_time=57',
        size3:
          'https://embed-ssl.wistia.com/deliveries/5c2058392f0f1e5867e134b0e102e00e.jpg?image_crop_resized=700x366\u0026video_still_time=57',
        size4:
          'https://embed-ssl.wistia.com/deliveries/5c2058392f0f1e5867e134b0e102e00e.jpg?image_crop_resized=570x260\u0026video_still_time=57',
        size5:
          'https://embed-ssl.wistia.com/deliveries/5c2058392f0f1e5867e134b0e102e00e.jpg?image_crop_resized=1000x1000\u0026video_still_time=57',
        size6:
          'https://embed-ssl.wistia.com/deliveries/5c2058392f0f1e5867e134b0e102e00e.jpg?image_crop_resized=1280x930\u0026video_still_time=57',
      },
      video_media: {
        size1:
          'http://embed.wistia.com/deliveries/a3387db64ea9232e3f328055416b94c8909357f1.mp4',
        size2:
          'http://embed.wistia.com/deliveries/60c9c92f19f0e082ce650790222349462304efae.mp4',
        size3:
          'http://embed.wistia.com/deliveries/9f5c6cf8b16689122cd46a3d6e3661380175909f.mp4',
        size4:
          'http://embed.wistia.com/deliveries/5c2058392f0f1e5867e134b0e102e00e.mp4',
        size5:
          'http://embed.wistia.com/deliveries/774d96c71ccf193757d6fd094905a60b5f90bcec.mp4',
      },
      materials: [
        {
          id: 190,
          name: 'Sand',
          description: null,
          link: null,
          price: null,
          created_at: '2018-11-21T02:13:06.000Z',
          updated_at: '2018-11-21T02:13:06.000Z',
          activity_materials_count: 5,
        },
        {
          id: 975,
          name: 'Simple Peg Puzzle',
          description: null,
          link: null,
          price: null,
          created_at: '2018-11-21T02:13:14.000Z',
          updated_at: '2018-11-21T02:13:14.000Z',
          activity_materials_count: 3,
        },
        {
          id: 1005,
          name: 'Tupperware',
          description: null,
          link: null,
          price: null,
          created_at: '2018-11-21T02:13:14.000Z',
          updated_at: '2018-11-21T02:13:14.000Z',
          activity_materials_count: 3,
        },
      ],
      milestones: [
        {
          id: 649,
          skill_id: 54,
          sub_skill_id: null,
          master: true,
          age: 48,
          active: true,
          created_at: '2018-11-08T17:35:05.000Z',
          updated_at: '2019-01-08T18:35:53.000Z',
          media_jpg_file_name: null,
          media_jpg_content_type: null,
          media_jpg_file_size: null,
          media_jpg_updated_at: null,
          media_mp4_file_name: '649_Video.mp4',
          media_mp4_content_type: 'video/mp4',
          media_mp4_file_size: 80068873,
          media_mp4_updated_at: '2019-01-08T18:35:52.000Z',
          title:
            'Cooperates with other children (for example, working towards the same goal at playtime)',
          description:
            'If your child cooperates with other children to achieve a same goal such as complete a puzzle or play a game, then {he/she} has completed this milestone.',
          science_fact:
            'Your child’s social and emotional development has led {him/her} to go from parallel play to cooperative play. This means your kid’s temporal lobe and frontal cortex are making connections which will help {him/her} practice executive function skills like mental flexibility and self-control.',
          source_data: 'Kinedu Research Team, 2018',
        },
        {
          id: 409,
          skill_id: 35,
          sub_skill_id: null,
          master: false,
          age: 36,
          active: true,
          created_at: '2018-11-08T17:35:05.000Z',
          updated_at: '2019-01-08T18:34:19.000Z',
          media_jpg_file_name: '409_Image.jpg',
          media_jpg_content_type: 'image/jpeg',
          media_jpg_file_size: 617015,
          media_jpg_updated_at: '2019-01-08T18:34:18.000Z',
          media_mp4_file_name: null,
          media_mp4_content_type: null,
          media_mp4_file_size: null,
          media_mp4_updated_at: null,
          title: "Completes simple peg or 'insert' puzzles",
          description:
            'If your child can complete simple peg or insert puzzles on {his/her} own, then {he/she} has completed this milestone. ',
          science_fact:
            'Inside your child’s brain, the corpus striatum is helping {him/her} organize {his/her} thoughts, weigh the options and prepare to insert a piece of a puzzle. ',
          source_data: 'Kinedu Research Team, 2018',
        },
      ],
      activity_type: 'activity',
    },
    complete: false,
  },
  {
    id: 5138,
    activity: {
      id: 5406,
      name: 'Rhyme it back! I',
      description:
        "To begin this activity, tell your child that you'll be focusing on rhymes today. Begin reading and have your child point out the words that rhyme. Help your youngster if {he/she} is not able to identify them. Then, have your toddler choose one of the rhyming words and make up a story about it. Try it yourself too, you might need to go first. Identifying rhymes will help your little one get more acquainted with different phonemes and expand {his/her} vocabulary.",
      purpose: 'To stimulate the acquisition of new words through rhymes.',
      area_id: 3,
      age: 46,
      age_group: '43-48',
      video_thumbnails: {
        size1:
          'https://embed-ssl.wistia.com/deliveries/0909c25fbb77f4e629a965f21157fa8e.jpg?image_crop_resized=250x250\u0026video_still_time=30',
        size2:
          'https://embed-ssl.wistia.com/deliveries/0909c25fbb77f4e629a965f21157fa8e.jpg?image_crop_resized=640x640\u0026video_still_time=30',
        size3:
          'https://embed-ssl.wistia.com/deliveries/0909c25fbb77f4e629a965f21157fa8e.jpg?image_crop_resized=700x366\u0026video_still_time=30',
        size4:
          'https://embed-ssl.wistia.com/deliveries/0909c25fbb77f4e629a965f21157fa8e.jpg?image_crop_resized=570x260\u0026video_still_time=30',
        size5:
          'https://embed-ssl.wistia.com/deliveries/0909c25fbb77f4e629a965f21157fa8e.jpg?image_crop_resized=1000x1000\u0026video_still_time=30',
        size6:
          'https://embed-ssl.wistia.com/deliveries/0909c25fbb77f4e629a965f21157fa8e.jpg?image_crop_resized=1280x930\u0026video_still_time=30',
      },
      video_media: {
        size1:
          'http://embed.wistia.com/deliveries/d843a647fe9891c5d8b70271371e14cbf6d59339.mp4',
        size2:
          'http://embed.wistia.com/deliveries/0e6dfb45130f2a350599231d1c289040d7f31c48.mp4',
        size3:
          'http://embed.wistia.com/deliveries/98329dc37f72d857425d18f44ddd0ee14a9188b6.mp4',
        size4:
          'http://embed.wistia.com/deliveries/fda72ee09c2a10ff3fcb4ef502d529931be7a766.mp4',
        size5:
          'http://embed.wistia.com/deliveries/0909c25fbb77f4e629a965f21157fa8e.mp4',
        size6:
          'http://embed.wistia.com/deliveries/3d8f644cf7ba945a00f641af399ba09580b10f77.mp4',
      },
      materials: [
        {
          id: 93,
          name: 'Rhyming Storybook',
          description: null,
          link: null,
          price: null,
          created_at: '2018-11-21T02:13:05.000Z',
          updated_at: '2018-11-21T02:13:05.000Z',
          activity_materials_count: 5,
        },
      ],
      milestones: [],
      activity_type: 'activity',
    },
    complete: false,
  },
];

export const KEYS_LOCALSTORAGE = {
  WHO_REDIRECT_PPPAYMENT: 'WHO_REDIRECT_PPPAYMENT',
  USER_ID: 'user_id',
  USER_TYPE: 'user_type',
  USER_EMAIL: 'user_email',
  ACTIVITY_VIEW_SOURCE: 'activityViewSource',
  ACTIVE_PLAN_ID: 'activePlanId',
  CURRRENT_VIEW_COMPONENT: 'CURRRENT_VIEW_COMPONENT',
  DAP_TYPE: 'DAP_TYPE',
  VIEW_HOW_IT_WORKS: 'VIEW_HOW_IT_WORKS',
  FIRST_ACT_SEEN: 'FIRST_ACTIVITY_SEEN',
  CUSTOMIZE_PROD_SENT: 'CUSTOMIZE_PRODUCT_SENT',
  AUTH_TOKEN: 'auth_token',
  ACTIVE_CENTER_NAME: 'ACTIVE_CENTER_NAME',
  ACTIVE_CENTER_ID: 'ACTIVE_CENTER_ID',
  ACTIVE_CENTER_EXTERNAL_ID: 'ACTIVE_CENTER_EXTERNAL_ID',
  CLASSROOM_NAME: 'CLASSROOM_NAME',
  CLASSROOM_ID: 'CLASSROOM_ID',
  ORGANIZATION_NAME: 'ORGANIZATION_NAME',
  ORGANIZATION_ID: 'ORGANIZATION_ID',
  ORGANIZATION_GLOBAL_ID: 'ORGANIZATION_GLOBAL_ID',
  ACCOUNT_TOKEN: 'account_token',
  UTM_SOURCE: 'utm_source',
  UTM_CAMPAIGN: 'utm_campaign',
  UTM_MEDIUM: 'utm_medium',
  UTM_CONTENT: 'utm_content',
  USER_LOCALE: 'user_locale',
  ACTIVE_CENTER_TOKEN: 'active_center_token',
  ACTIVE_GROUP_ID: 'selectedGroupId',
};

/**
 *
 * @param condition {Bollean} [Confidence to be fulfilled ]
 * @param component < Component /> [Component to be rendered if the cindion is met]
 * @param alternativeComponent < Component /> [Alternative component to render if condition is not met]
 * @param error Error [Error object]
 * @param errorView < Component /> [Error component to render if error is present]
 */
export const renderIf = (
  condition: any,
  loading: boolean,
  loadingState: any,
  component: any,
  alternativeComponent?: any,
  error?: any,
  errorView?: any,
) => {
  if (error) return errorView;
  if (loading) return loadingState;
  return condition ? component : alternativeComponent || null;
};

export const rendererIf = (condition: any, component:any, alternativeComponent?:any) =>
  condition ? component : alternativeComponent || null


export const userType = localStorage.getItem(KEYS_LOCALSTORAGE.USER_TYPE) || 'Owner';
export const USER_ROLE_TYPE = CLIENT_NAMESPACES[userType];
export const BabyMaxMonthAge = 48;

export const ITEMS_PER_PAGE = 7;

export const REVIEW_STATUS = {
  WAITING_FOR_REVIEW: 'waiting for review',
  NEED_CHANGES: 'need changes',
  APPROVED: 'approved',
};

export const DATE_FORMAT_ISO = 'yyyy-MM-dd';
